/* eslint import/prefer-default-export:off */

import { openDialog } from './ec-popup';

function setValidators() {
    const defaults = {};
    defaults.onkeyup = false;
    defaults.onclick = false;
    defaults.onfocusout = false;
    defaults.showErrors = (errorMap, errorList) => {
        if (!_.isEmpty(errorList) && errorList.length) {
            openDialog('message', errorList[0].message);
        }
    };
    $.validator.setDefaults(defaults);

    $.extend($.validator.messages, {
        required: '반드시 입력해야 합니다.',
        email: '올바른 E-Mail 주소가 아닙니다.',
        url: ': 올바른 URL이 아닙니다.',
        date: ': 날짜가 잘못 입력됐습니다.',
        dateISO: ': ISO 형식에 맞는 날짜로 입력하세요.',
        number: ': 숫자만 입력하세요.',
        digits: ': 숫자(digits)만 입력하세요.',
        creditcard: ': 올바른 신용카드 번호를 입력하세요.',
        maxlength: $.validator.format(': {0}글자 이상은 입력할 수 없습니다.'),
        minlength: $.validator.format(': 적어도 {0}글자는 입력해야 합니다.'),
        rangelength: $.validator.format(': {0}글자 이상 {1}글자 이하로 입력해 주세요.'),
        range: $.validator.format(': {0}에서 {1} 사이의 값을 입력하세요.'),
        max: $.validator.format(': {0} 이하로 입력해 주세요.'),
        min: $.validator.format(': {0} 이상으로 입력해 주세요.'),
        equal: ': 값이 일치하지 않습니다.',
    });

    // 주민등록번호 (SSN)
    $.validator.addMethod('ssn', (value, element) => {
        const v = value.replace(/-/g, '');
        let sum = 0;

        if (this.optional(element) || v.match(/\d{2}[0-1]\d{1}[0-3]\d{1}\d{7}/)) {
            if (v.substr(6, 1) >= 5 && v.substr(6, 1) <= 8) { // 외국인
                if (Number(v.substr(7, 2)) % 2 !== 0) return false;

                for (let i = 0; i < 12; i += 1) {
                    sum += Number(v.substr(i, 1)) * ((i % 8) + 2);
                }

                if (((((11 - (sum % 11)) % 10) + 2) % 10) === Number(v.substr(12, 1))) {
                    return true;
                }
            } else { // 내국인
                for (let i = 0; i < 12; i += 1) {
                    sum += Number(v.substr(i, 1)) * ((i % 8) + 2);
                }
                if (((11 - (sum % 11)) % 10) === Number(v.substr(12, 1))) {
                    return true;
                }
            }
        }
        return false;
    }, '올바른 주민등록번호가 아닙니다.');

    // 사업자등록번호 (crn)
    $.validator.addMethod('crn', (value, element) => {
        const checkID = [1, 3, 7, 1, 3, 7, 1, 3, 5, 1];
        const v = value.replace(/-/gi, '');
        let chkSum = 0;
        let c2;

        for (let i = 0; i <= 7; i += 1) {
            chkSum += checkID[i] * v.charAt(i);
        }
        c2 = `0${(checkID[8] * v.charAt(8))}`;
        c2 = c2.substring(c2.length - 2, c2.length);
        chkSum += Math.floor(c2.charAt(0)) + Math.floor(c2.charAt(1));
        const remander = (10 - (chkSum % 10)) % 10;
        return this.optional(element) || Math.floor(value.charAt(9)) === remander;
    }, '올바른 사업자등록번호가 아닙니다.');

    // 하이픈을 포함한 전화번호
    $.validator.addMethod('phone', (value, element) => this.optional(element) || /^\d{2,3}-\d{3,4}-\d{4}$/.test(value), '올바른 전화번호가 아닙니다.');

    // 하이픈을 포함한 휴대폰 번호
    $.validator.addMethod('mobile', (value, element) => this.optional(element) || /^01([0|1|6|7|8|9]?)-(\d{3,4})-(\d{4})$/.test(value), '올바른 휴대폰번호가 아닙니다.');

    // 우편번호
    $.validator.addMethod('postal', (value, element) => this.optional(element) || /^\d{5}$/.test(value), '올바른 우편번호가 아닙니다.');

    // required
    $('.required').attr('data-rule-required', true);

    // minValue
    $('input[data-min-value]').each((index, element) => {
        const value = $(element).attr('data-min-value');
        $(element).attr('data-rule-min', value);

        if (_.isInteger(value)) {
            $(element).attr('data-rule-digits', true);
        } else {
            $(element).attr('data-rule-number', true);
        }
    });

    // maxValue
    $('input[data-max-value]').each((index, element) => {
        const value = $(element).attr('data-max-value');
        $(element).attr('data-rule-max', value);

        if (_.isInteger(value)) {
            $(element).attr('data-rule-digits', true);
        } else {
            $(element).attr('data-rule-number', true);
        }
    });

    // rangeValue
    $('input[data-range-value]').each((index, element) => {
        const value = $(element).attr('data-range-value');
        $(element).attr('data-rule-range', value);

        if (_.isInteger(value)) {
            $(element).attr('data-rule-digits', true);
        } else {
            $(element).attr('data-rule-number', true);
        }
    });

    // minLength
    $('input[data-min-length]').each((index, element) => {
        const value = $(element).attr('data-min-length');
        $(element).attr('data-rule-minlength', value);
    });

    // maxLength
    $('input[data-max-length]').each((index, element) => {
        const value = $(element).attr('data-max-length');
        $(element).attr('data-rule-maxlength', value);
    });

    // rangeLength
    $('input[data-range-length]').each((index, element) => {
        const value = $(element).attr('data-range-length');
        $(element).attr('data-rule-rangelength', value);
    });

    // format
    $('input[data-format]').each((index, element) => {
        const format = $(element).attr('data-format');

        if (_.isEqual(format, 'ssn')) {
            $(element).attr('data-rule-ssn', true);
        } else if (_.isEqual(format, 'crn')) {
            $(element).attr('data-rule-crn', true);
        } else if (_.isEqual(format, 'email')) {
            $(element).attr('data-rule-email', true);
        } else if (_.isEqual(format, 'phone')) {
            $(element).attr('data-rule-phone', true);
        } else if (_.isEqual(format, 'mobile')) {
            $(element).attr('data-rule-mobile', true);
        } else if (_.isEqual(format, 'postal')) {
            $(element).attr('data-rule-postal', true);
        }
    });
}

export { setValidators as default };



// WEBPACK FOOTER //
// ./src/utils/ec-validator.js